import { createSlice } from '@reduxjs/toolkit'

interface AnalysisState {
    data: any[]
    userAnalysisData: any[]
    loading: boolean
}

const initialState: AnalysisState = {
    data: [],
    userAnalysisData: [],
    loading: false
}

const analysisSlice = createSlice({
    name: 'analysis',
    initialState: initialState,
    reducers: {
        setAnalysisData: (state, action) => {
            state.data = action.payload
        },
        setUserAnalysisData: (state, action) => {
            state.userAnalysisData = action.payload
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        }
    }
})

export const { setAnalysisData, setUserAnalysisData, setLoading } = analysisSlice.actions
export default analysisSlice.reducer
